export const SUB_PAGES = {
	INFO: 'info',
	SECURITY: 'security',
	UPGRADE: 'upgrade',
};
